'use strict';

// CUSTOM: Initialize Promo Bar with Slick integration
var promoBar = require('./globalHeaderAnnouncement');
// FULL OVERRIDE of base/components/menu
// This file completely replaces base cartridge menu functionality with custom modifications

var keyboardAccessibility = require('base/components/keyboardAccessibility');

var clearSelection = function (element) {
    $(element).closest('.dropdown').children('.dropdown-menu').children('.top-category')
        .detach();
    $(element).closest('.dropdown.show').children('.nav-link').attr('aria-expanded', 'false');
    $(element).closest('.dropdown.show').children('.dropdown-menu').attr('aria-hidden', 'true');
    $(element).closest('.dropdown.show').removeClass('show');
    $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'false');
    $(element).closest('li').detach();
};

/**
 * Initialize sticky header behavior (Callebaut-style)
 * Only makes the nav sticky, not the header-banner
 */
function initStickyHeader() {
    var header = document.querySelector('header');
    var nav = document.querySelector('header > nav');
    if (!header || !nav || nav.classList.contains('no-sticky')) return;

    var navHeight = nav.offsetHeight;
    var scrollThreshold = 250;
    var scrollThresholdExit = scrollThreshold - 50;
    var directionAnchor = 0;
    var currentDirection = null;
    var directionChangeBuffer = 8;
    var isInStickyZone = false;

    /**
     * Handle scroll event to toggle sticky navigation
     */
    function handleScroll() {
        var currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (!isInStickyZone && currentScrollTop > scrollThreshold) {
            isInStickyZone = true;
            directionAnchor = currentScrollTop;
            currentDirection = 'down';
            nav.classList.remove('is-sticky');
        }

        if (isInStickyZone && currentScrollTop < scrollThresholdExit) {
            isInStickyZone = false;
            nav.classList.remove('is-sticky');
            nav.classList.remove('is-sticky-hidden');
            document.body.style.paddingTop = '0';
            currentDirection = null;
            directionAnchor = currentScrollTop;
            return;
        }

        if (isInStickyZone) {
            var delta = currentScrollTop - directionAnchor;

            if (delta > directionChangeBuffer && currentDirection !== 'down') {
                currentDirection = 'down';
                directionAnchor = currentScrollTop;
                nav.classList.remove('is-sticky');
                nav.classList.add('is-sticky-hidden');
            } else if (delta < -directionChangeBuffer && currentDirection !== 'up') {
                currentDirection = 'up';
                directionAnchor = currentScrollTop;
                nav.classList.add('is-sticky');
                nav.classList.remove('is-sticky-hidden');
            }

            if ((currentDirection === 'down' && currentScrollTop > directionAnchor) || (currentDirection === 'up' && currentScrollTop < directionAnchor)) {
                directionAnchor = currentScrollTop;
            }
        }
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
        if (!ticking) {
            window.requestAnimationFrame(function () {
                handleScroll();
                ticking = false;
            });
            ticking = true;
        }
    });

    handleScroll();
}

/**
 * Prevent body scroll when mobile menu modal is open
 */
function preventBodyScroll() {
    var menuModal = document.querySelector('.menu-toggleable-left');
    if (!menuModal) return;

    // Use MutationObserver to watch for class changes
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.attributeName === 'class') {
                var target = mutation.target;
                if (target.classList.contains('in')) {
                    // Modal is open - prevent body scroll
                    document.body.style.overflow = 'hidden';
                    document.body.style.position = 'fixed';
                    document.body.style.width = '100%';
                } else {
                    // Modal is closed - restore body scroll
                    document.body.style.overflow = '';
                    document.body.style.position = '';
                    document.body.style.width = '';
                }
            }
        });
    });

    // Start observing the menu modal for class changes
    observer.observe(menuModal, {
        attributes: true,
        attributeFilter: ['class']
    });
}

module.exports = function () {
    const isDesktop = function (element) {
        return $(element).parents('.menu-toggleable-left').css('position') !== 'fixed';
    };

    const headerBannerStatus = window.sessionStorage.getItem('hide_header_banner');
    $('.header-banner .close').on('click', function () {
        $('.header-banner').addClass('d-none');
        window.sessionStorage.setItem('hide_header_banner', '1');
    });

    if (!headerBannerStatus || headerBannerStatus < 0) {
        $('.header-banner').removeClass('d-none');
    }

    keyboardAccessibility(
        '.main-menu .nav-link, .main-menu .dropdown-link',
        {
            40: function (menuItem) { // down
                if (menuItem.hasClass('nav-item')) { // top level
                    $('.navbar-nav .show').removeClass('show')
                        .children('.dropdown-menu')
                        .removeClass('show');
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                } else {
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    if (!(menuItem.next().length > 0)) { // if this is the last menuItem
                        menuItem.parent().parent().find('li > a') // set focus to the first menuitem
                            .first()
                            .focus();
                    } else {
                        menuItem.next().children().first().focus();
                    }
                }
            },
            39: function (menuItem) { // right
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.next().children().first().focus();
                } else if (menuItem.hasClass('dropdown')) {
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    $(this).attr('aria-expanded', 'true');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                }
            },
            38: function (menuItem) { // up
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                } else if (menuItem.prev().length === 0) { // first menuItem
                    menuItem.parent().parent().removeClass('show')
                        .children('.nav-link')
                        .attr('aria-expanded', 'false');
                    menuItem.parent().children().last().children() // set the focus to the last menuItem
                        .first()
                        .focus();
                } else {
                    menuItem.prev().children().first().focus();
                }
            },
            37: function (menuItem) { // left
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.prev().children().first().focus();
                } else {
                    menuItem.closest('.show').removeClass('show')
                        .closest('li.show').removeClass('show')
                        .children()
                        .first()
                        .focus()
                        .attr('aria-expanded', 'false');
                }
            },
            27: function (menuItem) { // escape
                var parentMenu = menuItem.hasClass('show')
                    ? menuItem
                    : menuItem.closest('li.show');
                parentMenu.children('.show').removeClass('show');
                parentMenu.removeClass('show').children('.nav-link')
                    .attr('aria-expanded', 'false');
                parentMenu.children().first().focus();
            }
        },
        function () {
            return $(this).parent();
        }
    );

    // CUSTOM: Modified dropdown behavior for desktop mega menu (SharkNinja style)

    // Handle keyboard navigation for desktop dropdowns
    $('.navbar-nav > .nav-item.dropdown > .nav-link')
        .on('keydown', function (e) {
            if (isDesktop(this)) {
                var $navItem = $(this).parent();

                // Enter (13) or Space (32) should open the dropdown, not follow the link
                if (e.which === 13 || e.which === 32) {
                    e.preventDefault();

                    // Close other dropdowns
                    $('.navbar-nav > .nav-item.dropdown').not($navItem).each(function () {
                        $(this).removeClass('show');
                        $(this).children('.dropdown-menu').removeClass('show');
                        $(this).children('.nav-link').attr('aria-expanded', 'false');
                    });

                    // Toggle current dropdown
                    if ($navItem.hasClass('show')) {
                        $navItem.removeClass('show');
                        $navItem.children('.dropdown-menu').removeClass('show');
                        $(this).attr('aria-expanded', 'false');
                    } else {
                        $navItem.addClass('show');
                        $navItem.children('.dropdown-menu').addClass('show');
                        $navItem.find('.dropdown-menu').addClass('show');
                        $(this).attr('aria-expanded', 'true');

                        // Focus first item in dropdown menu
                        setTimeout(function () {
                            $navItem.find('.dropdown-menu > li > a, .dropdown-menu > .dropdown-item > a').first().focus();
                        }, 100);
                    }
                } else if (e.which === 27) {
                    // Escape (27) should close the dropdown
                    $navItem.removeClass('show');
                    $navItem.children('.dropdown-menu').removeClass('show');
                    $navItem.find('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                }
            }
        });

    // Handle mobile click behavior
    $('.dropdown:not(.disabled) [data-toggle="dropdown"]')
        .on('click', function (e) {
            if (!isDesktop(this)) {
                $('.modal-background').show();
                // copy parent element into current UL
                var li = $('<li class="dropdown-item top-category" role="button"></li>');
                var link = $(this).clone().removeClass('dropdown-toggle')
                    .removeAttr('data-toggle')
                    .removeAttr('aria-expanded')
                    .attr('aria-haspopup', 'false');
                li.append(link);
                // Create nav-menu with only back button (not close button)
                var navMenu = $('<li class="nav-menu"></li>');
                var backButton = $('.back-button-container .back').first().clone();
                backButton.find('.level-title').append($(this).text());
                navMenu.append(backButton);
                $(this).parent().children('.dropdown-menu')
                    .prepend(navMenu)
                    .attr('aria-hidden', 'false');
                // copy navigation menu into view
                $(this).parent().addClass('show');
                $(this).attr('aria-expanded', 'true');
                $(link).focus();
                $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'true');
                e.preventDefault();
            }
        });

    // COMMENTED OUT: Hover behavior disabled - only click to open/close
    $('.navbar-nav > .nav-item.dropdown')
        .on('mouseenter', function () {
            if (isDesktop(this)) {
                var $currentNavItem = $(this);

                // Close other open dropdowns
                $('.navbar-nav > .nav-item.dropdown').each(function () {
                    if (this !== $currentNavItem[0]) {
                        $(this).removeClass('show');
                        $(this).children('.dropdown-menu').removeClass('show');
                        $(this).children('.nav-link').attr('aria-expanded', 'false');
                    }
                });

                // CUSTOM: Open current dropdown and ALL nested dropdowns for mega menu
                $currentNavItem.find('.dropdown-menu .dropdown-item .dropdown-menu-content-images').removeClass('d-none');
                $currentNavItem.addClass('show');
                $currentNavItem.children('.dropdown-menu').addClass('show');
                // Show all nested dropdowns (L2, L3) automatically
                $currentNavItem.find('.dropdown-menu').addClass('show');
                $currentNavItem.children('.nav-link').attr('aria-expanded', 'true');
            }
        })
        .on('mouseleave', function () {
            // CUSTOM: Close when mouse leaves the nav-item area
            if (isDesktop(this)) {
                $(this).removeClass('show');
                $(this).children('.dropdown-menu').removeClass('show');
                $(this).children('.dropdown-menu').find('.dropdown-menu').removeClass('show');
                $(this).find('.dropdown-item .dropdown-menu-content-images').addClass('d-none');
                $(this).children('.nav-link').attr('aria-expanded', 'false');
            }
        });

    $('.navbar>.close-menu>.close-button').on('click', function (e) {
        e.preventDefault();
        $('.menu-toggleable-left').removeClass('in');
        $('.modal-background').hide();

        $('.navbar-toggler').focus();

        $('.main-menu').attr('aria-hidden', 'true');
        $('.main-menu').siblings().attr('aria-hidden', 'false');
        $('header').siblings().attr('aria-hidden', 'false');
    });

    $('.navbar-nav').on('click', '.back', function (e) {
        e.preventDefault();
        clearSelection(this);
    });

    $('.navbar-nav').on('click', '.close-button', function (e) {
        e.preventDefault();
        $('.navbar-nav').find('.top-category').detach();
        $('.navbar-nav').find('.nav-menu').detach();
        $('.navbar-nav').find('.show').removeClass('show');
        $('.menu-toggleable-left').removeClass('in');

        $('.main-menu').siblings().attr('aria-hidden', 'false');
        $('header').siblings().attr('aria-hidden', 'false');

        $('.modal-background').hide();
    });

    $('.navbar-toggler').click(function (e) {
        e.preventDefault();
        $('.main-menu').toggleClass('in');
        $('.modal-background').show();

        $('.main-menu').removeClass('d-none');
        $('.main-menu').attr('aria-hidden', 'false');
        $('.main-menu').siblings().attr('aria-hidden', 'true');
        $('header').siblings().attr('aria-hidden', 'true');

        $('.main-menu .nav.navbar-nav .nav-link').first().focus();
    });

    keyboardAccessibility(
        '.navbar-header .user',
        {
            40: function ($popover) { // down
                if ($popover.children('a').first().is(':focus')) {
                    $popover.next().children().first().focus();
                } else {
                    $popover.children('a').first().focus();
                }
            },
            38: function ($popover) { // up
                if ($popover.children('a').first().is(':focus')) {
                    $(this).focus();
                    $popover.removeClass('show');
                } else {
                    $popover.children('a').first().focus();
                }
            },
            27: function () { // escape
                $('.navbar-header .user .popover').removeClass('show');
                $('.user').attr('aria-expanded', 'false');
            },
            9: function () { // tab
                $('.navbar-header .user .popover').removeClass('show');
                $('.user').attr('aria-expanded', 'false');
            }
        },
        function () {
            var $popover = $('.user .popover li.nav-item');
            return $popover;
        }
    );

    $('.navbar-header .user').on('mouseenter focusin', function () {
        if ($('.navbar-header .user .popover').length > 0) {
            $('.navbar-header .user .popover').addClass('show');
            $('.user').attr('aria-expanded', 'true');
        }
    });

    $('.navbar-header .user').on('mouseleave', function () {
        $('.navbar-header .user .popover').removeClass('show');
        $('.user').attr('aria-expanded', 'false');
    });

    $('body').on('click', '#myaccount', function (event) {
        event.preventDefault();
    });

    // CUSTOM: Initialize sticky header
    initStickyHeader();

    // CUSTOM: Prevent body scroll when mobile menu is open
    preventBodyScroll();

    // CUSTOM: L3 submenu accordion toggle
    $(document).on('click', '.submenu-toggle', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $parent = $(this).closest('[data-toggle-submenu]');
        var $submenu = $parent.find('> .dropdown-submenu');
        var $arrow = $(this).find('.submenu-arrow');

        // Toggle expanded class
        $submenu.toggleClass('expanded');
        $arrow.toggleClass('expanded');

        // Update aria-expanded
        var isExpanded = $submenu.hasClass('expanded');
        $(this).attr('aria-expanded', isExpanded);
    });

    // CUSTOM: Also toggle when clicking on the arrow itself
    $(document).on('click', '.submenu-arrow', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $link = $(this).closest('.submenu-toggle');
        $link.trigger('click');
    });

    promoBar.initPromoBar();
};
